export const type = 'showNewProduct';

const showNewProduct = () => ({
    type,
    payload: null,
});

export default showNewProduct;